import { ITileV3 } from './3';
import { IVisualOptionsV2 } from './2';

export interface IVisualOptionsV3 extends IVisualOptionsV2 {
    horizontalLine: string;
    verticalLine: string;
}

export interface ITileV4 extends Omit<ITileV3, 'visualOptions'> {
    visualOptions: Partial<IVisualOptionsV3>;
}

export function up(prev: ITileV3): ITileV4 {
    return prev;
}
